// Loading skeleton for the Edit Order Details page. Mirrors the spacing and
// element sizes in EditOrderDetailsForm so rows land in the same screen
// positions when the live form mounts. Keep in sync with
// app/components/skeletons/edit_order_details.rb so React hydrates the SSR
// skeleton without restarting the shimmer animation.

import {
  Bar,
  DEFAULT_LABEL,
  DetailFooter,
  DetailHeader,
  PageShell,
} from './primitives';

function FormFieldBar() {
  return (
    <div>
      <Bar className="h-[20px] w-[72px] mb-1.5" />
      <Bar className="h-[46px] w-full rounded-input" />
    </div>
  );
}

export function EditOrderDetailsSkeleton({ label = DEFAULT_LABEL }: { label?: string }) {
  return (
    <PageShell label={label}>
      <DetailHeader crumbs={3} />
      <div className="flex flex-col flex-1 min-h-0 overflow-y-auto py-8">
        <div className="w-full px-16 space-y-8">
          <Bar className="h-[30px] w-32" />

          <div className="flex flex-col gap-16">
            <section className="flex flex-col gap-4">
              <Bar className="h-[23px] w-44" />
              <div className="grid grid-cols-[7fr_7fr_10fr] grid-rows-2 gap-8">
                <FormFieldBar />
                <FormFieldBar />
                <div className="row-span-2 col-start-3">
                  <Bar className="h-[20px] w-[100px] mb-1.5" />
                  <Bar className="h-[147px] w-full rounded-input" />
                </div>
                <FormFieldBar />
                <FormFieldBar />
              </div>
            </section>

            <div className="border-t border-dinnerplate-white" />

            <section className="flex flex-col gap-4">
              <Bar className="h-[23px] w-32" />
              <div className="grid grid-cols-[7fr_7fr_10fr] gap-8">
                <FormFieldBar />
                <FormFieldBar />
              </div>
            </section>

            <div className="border-t border-dinnerplate-white" />

            <section className="flex flex-col gap-4">
              <Bar className="h-[23px] w-56" />
              <div className="grid grid-cols-[7fr_7fr_10fr] gap-8">
                <FormFieldBar />
                <FormFieldBar />
                <div className="col-start-1"><FormFieldBar /></div>
              </div>
            </section>
          </div>
        </div>
      </div>
      <DetailFooter buttonClass="h-[42px] w-[131px]" />
    </PageShell>
  );
}
